import {Injectable, NgZone} from '@angular/core';
import {Geolocation} from '@ionic-native/geolocation/ngx';
import {NativeGeocoder, NativeGeocoderOptions, NativeGeocoderResult} from '@ionic-native/native-geocoder/ngx';
import {Platform} from '@angular/cdk/platform';
import {AuthService} from './auth.service';
import {ApiService} from './api.service';
import {Router} from '@angular/router';
import {HandlerService} from './handler.service';
import {IonGrid} from '@ionic/angular';


declare var google;

@Injectable({providedIn: 'root'})
export class LocationService {

    autoComp = null;
    houseNbr;
    zipcode;
    street;
    regionId;
    flatName;
    cityId;
    stateId;
    lat;
    lon;
    dummy = false;
    pop: boolean;
    newSearch;
    url;
    typeId;
    subscriptionId;
    markedPrice;
    trigger: boolean;
    regionIdName;
    countryCode;
    serviceArea: boolean;
    locationTrue: boolean;
    booking: boolean = false;

    // latitude;longtitude;

    constructor(private location: Geolocation,
                private platform: Platform,
                private ngZone: NgZone,
                private router: Router,
                private nativeGeocoder: NativeGeocoder,
                private auth: AuthService,
                private service: ApiService,
                private handler: HandlerService
    ) {
    }

    ionViewWillEnter() {

    }

    getLocation() {
        if (this.platform.ANDROID || this.platform.IOS) {
            let options: NativeGeocoderOptions = {useLocale: true, maxResults: 1};
            this.location.getCurrentPosition().then(res => {
                this.nativeGeocoder.reverseGeocode(res.coords.latitude, res.coords.longitude, options)
                    .then((result: NativeGeocoderResult[]) => {
                        let x: any = result;
                        localStorage.setItem('location', JSON.stringify(x));
                    }, error => {

                    });
            }, error => {
            })
        }
    }

    autoComplete() {
        if (!this.dummy) {
            this.dummy = true;
            if (localStorage.getItem('location')) {
                let x = JSON.parse(localStorage.getItem('location'));
                this.autoComp = new google.maps.places.Autocomplete(event.target, {
                    types: ['establishment', 'geocode'],
                    componentRestrictions: {country: x[0].countryCode}
                })
            } else {
                this.autoComp = new google.maps.places.Autocomplete(event.target, {types: ['establishment', 'geocode']})
            }
            this.autoComp.setFields(['address_component', 'geometry']);
        }
        if (this.dummy) {
            this.autoComp.addListener("place_changed", () => {
                this.ngZone.run(() => {
                    this.houseNbr = '';
                    this.zipcode = '';
                    this.street = '';
                    this.cityId = '';
                    this.regionId = '';
                    this.stateId = '';
                    this.onGetPlaces(this.autoComp.getPlace());
                });
            });
        }
    }

    autoComplete123() {
        if (!this.dummy) {
            this.dummy = true;
            if (localStorage.getItem('location')) {
                let x = JSON.parse(localStorage.getItem('location'));
                this.autoComp = new google.maps.places.Autocomplete(event.target, {
                    types: ['establishment', 'geocode'],
                    componentRestrictions: {country: x[0].countryCode}
                })
            } else {
                this.autoComp = new google.maps.places.Autocomplete(event.target, {types: ['establishment', 'geocode']})
            }
            this.autoComp.setFields(['address_component', 'geometry']);
        }
        if (this.dummy) {
            this.autoComp.addListener("place_changed", () => {
                this.ngZone.run(() => {
                    this.handler.doorNbr = '';
                    this.handler.zipcode = '';
                    this.handler.street = '';
                    this.handler.cityId = '';
                    this.handler.regionId = '';
                    this.handler.stateId = '';
                    this.onGetPlaces123(this.autoComp.getPlace());
                });
            });
        }
    }

    contractorFilterautoComplete() {
        if (!this.dummy) {
            this.dummy = true;
            if (localStorage.getItem('countryCode')) {
                let x = localStorage.getItem('countryCode');
                this.autoComp = new google.maps.places.Autocomplete(event.target, {
                    types: ['establishment', 'geocode'],
                    componentRestrictions: {country: x},
                });
            } else {
                this.autoComp = new google.maps.places.Autocomplete(event.target, {
                    types: ['establishment', 'geocode'],
                });
            }
            this.autoComp.setFields(['address_component', 'geometry']);
        }
        if (this.dummy) {
            this.autoComp.addListener('place_changed', () => {
                this.ngZone.run(() => {
                    this.houseNbr = '';
                    this.zipcode = '';
                    this.street = '';
                    this.cityId = '';
                    this.regionId = '';
                    this.stateId = '';
                    this.contractorFilterOnGetPlaces(this.autoComp.getPlace());
                });
            });
        }
    }


    contractorFilterOnGetPlaces(data) {
        this.lat = data.geometry.location.lat();
        this.lon = data.geometry.location.lng();
        this.handler.cityId = "";
        this.handler.regionId = "";
        data.address_components.map((res) => {


            console.log(this.handler.cityId, this.handler.regionId)
            if (res.types.includes("administrative_area_level_2")) {
                return this.handler.cityId = res.long_name;
            } else if (res.types.includes("locality") || res.types.includes("sublocality") || res.types.includes("neighborhood")) {
                return this.handler.regionId = res.long_name;
            }

            if (this.lat && this.lon) {
                localStorage.removeItem('location')
                var latLon = {lat: this.lat, lon: this.lon}
                localStorage.setItem('location', JSON.stringify(latLon))
                return this.handler.lat = this.lat, this.handler.lon = this.lon;

            }
        });


        this.newSearch = '';
        this.pop = false;
        setTimeout(() => {
            this.dummy = false;
        }, 1000);


        // localStorage.removeItem("location");
        var location = []
        if (this.lat && this.lon) {
            location.push({
                lat: this.lat,
                lon: this.lon
            });
        }
        localStorage.setItem('location', JSON.stringify(location));
        localStorage.setItem('place', JSON.stringify(data.address_components));


        setTimeout(() => {
            if (this.handler.cityId && this.handler.regionId) {
                this.newSearch = this.handler.regionId + ', ' + this.handler.cityId;
                console.log(this.newSearch);
            } else if (this.handler.regionId) {
                this.newSearch = this.handler.regionId;
                console.log(this.newSearch);
            } else {
                this.newSearch = this.handler.cityId;
            }
        }, 400);
        google.maps.event.removeListener(this.autoComp);
    }


    onGetPlaces123(data) {
        this.handler.lat = data.geometry.location.lat();
        this.handler.lon = data.geometry.location.lng();
        // this.handler.latitude  = data.geometry.location.lat();
        // this.handler.longtitude = data.geometry.location.lng();
        data.address_components.map(res => {
            if (res.types.includes("street_number")) {
                return this.handler.doorNbr = res.long_name;
            } else if (res.types.includes("postal_code")) {
                return this.handler.zipcode = res.long_name;
            } else if (res.types.includes("route")) {
                return this.handler.street = res.long_name;
            } else if (res.types.includes("locality") || res.types.includes("administrative_area_level_2")) {
                return this.handler.cityId = res.long_name;
            } else if (res.types.includes("sublocality") || res.types.includes("neighborhood")) {
                return this.handler.regionId = res.long_name;
            } else if (res.types.includes("administrative_area_level_1")) {
                return this.handler.stateId = res.long_name;
            } else if (res.types.includes("country")) {
                sessionStorage.setItem("CountryCode", res.short_name)
                // return this.countryCode = res.short_name;
            }

            this.newSearch = "";
            this.pop = false;

        })
        setTimeout(() => {
            this.dummy = false;
        }, 1000);

        if (this.subscriptionId != undefined && this.regionId != undefined && this.typeId != undefined &&
            this.subscriptionId != "" && this.regionId != "" && this.typeId != "") {
            this.getCost();
            this.trigger = false;
        }
        if (this.serviceArea) {
            this.newUserPage()
            this.getLocationDetails();
            this.serviceArea = false;
        }

        localStorage.removeItem("location");
        localStorage.setItem('place', JSON.stringify(data.address_components));
    }

    onGetPlaces(data) {
        this.lat = data.geometry.location.lat();
        this.lon = data.geometry.location.lng();
        localStorage.setItem('lat', this.lat)
        localStorage.setItem('lon', this.lon)
        // this.latitude  = data.geometry.location.lat();
        // this.longtitude = data.geometry.location.lng();
        data.address_components.map(res => {
            if (res.types.includes("street_number")) {
                return this.houseNbr = res.long_name;
            } else if (res.types.includes("postal_code")) {
                return this.zipcode = res.long_name;
            } else if (res.types.includes("route")) {
                return this.street = res.long_name;
            } else if (res.types.includes("locality") || res.types.includes("administrative_area_level_2")) {
                return this.cityId = res.long_name;
            } else if (res.types.includes("sublocality") || res.types.includes("neighborhood")) {
                return this.regionId = res.long_name;
            } else if (res.types.includes("administrative_area_level_1")) {
                return this.stateId = res.long_name;
            } else if (res.types.includes("country")) {
                sessionStorage.setItem("CountryCode", res.short_name)
                // return this.countryCode = res.short_name;
            }

            this.newSearch = "";
            this.pop = false;

        })
        setTimeout(() => {
            this.dummy = false;
        }, 1000);

        if (this.subscriptionId != undefined && this.regionId != undefined && this.typeId != undefined &&
            this.subscriptionId != "" && this.regionId != "" && this.typeId != "") {
            this.getCost();
            this.trigger = false;
        }
        if (this.serviceArea) {
            this.newUserPage()
            this.getLocationDetails();
            this.serviceArea = false;
        }

        localStorage.removeItem("location");
        localStorage.setItem('place', JSON.stringify(data.address_components));
    }

    getLocationDetails() {
        var x;
        // if(this.regionId=="" || this.regionId==null ||this.regionId==undefined || !this.regionId ){
        x = this.cityId
        // }else{
        // x = this.regionId
        // }
        // console.log("therans")
        if (this.serviceArea) {
            if (this.cityId == "Chennai" || this.cityId == "chennai" || this.cityId == "CHENNAI" ||
                this.cityId == "Thiruvallur" || this.cityId == "thiruvallur" || this.cityId == "THIRUVALLUR" ||
                this.cityId == "Tiruvallur" || this.cityId == "tiruvallur" || this.cityId == "TIRUVALLUR") {
                var post = {
                    "id": 790,
                    "city": x
                }
                this.service.locationSearch(post).subscribe((res: any) => {
                    if (res != null || res == 'OK') {
                        this.locationTrue = true;
                        localStorage.setItem('locationTrue', 'true');
                        // this.newUserPage()
                    } else {
                        this.locationTrue = false;
                        localStorage.setItem('locationTrue', 'false');
                        this.handler.err('Selected service is not provided in this region!!! Please select different region');
                        // this.newUserPage()
                    }
                }, err => {
                    this.locationTrue = false;
                    localStorage.setItem('locationTrue', 'false');
                    this.handler.err(err);
                    // this.newUserPage()
                })
            } else {
                var post1 = {
                    "id": 790,
                    "region": x
                }
                this.service.locationSearch(post1).subscribe((res: any) => {
                    if (res != null || res == "OK") {
                        this.locationTrue = true;
                        localStorage.setItem('locationTrue', 'true');
                        // this.newUserPage()
                    } else {
                        this.locationTrue = false;
                        localStorage.setItem('locationTrue', 'false');
                        this.handler.err('Selected service is not provided in this region!!! Please select different region');
                        // this.newUserPage()
                    }
                }, err => {
                    this.locationTrue = false;
                    localStorage.setItem('locationTrue', 'false');
                    this.handler.err(err);
                    // this.newUserPage()
                })
            }
        }
    }

    newUserPage() {
        this.url = window.location.href;
        if (this.url.includes('set-location')) {
            this.router.navigate(['/bookservice']);
        }
    }

    openPop() {
        this.pop = true;
        this.trigger = true;
    }

    getCost() {
        if (this.trigger) {
            var data = {
                "itemTypeId": this.typeId,
                "region": this.regionId,
                "serviceId": this.subscriptionId
            }
            this.service.getCost(data).subscribe((res: any) => {
                if (res != null) {
                    this.markedPrice = res[0].cost;
                } else {
                    this.handler.res("Please Select Different Location");
                    this.markedPrice = "";
                }
            }, err => {
                this.handler.err(err);
            })
        }
    }

    ionViewWillLeave() {
        sessionStorage.removeItem('typeId');
        sessionStorage.removeItem('serviceId');
    }

    autoComplete1() {
        if (!this.dummy) {
            this.dummy = true;
            if (localStorage.getItem('location')) {
                let x = JSON.parse(localStorage.getItem('location'));
                this.autoComp = new google.maps.places.Autocomplete(event.target, {
                    types: ['establishment', 'geocode'],
                    componentRestrictions: {country: x[0].countryCode}
                })
            } else {
                this.autoComp = new google.maps.places.Autocomplete(event.target, {types: ['establishment', 'geocode']})
            }
            this.autoComp.setFields(['address_component', 'geometry']);
        }
        if (this.dummy) {
            this.autoComp.addListener("place_changed", () => {
                this.ngZone.run(() => {
                    this.regionIdName = '';
                    this.onGetPlaces1(this.autoComp.getPlace());
                });
            });
        }
    }

    onGetPlaces1(data) {
        data.address_components.map(res => {

            if (res.types.includes("sublocality")) {
                return this.regionIdName = res.long_name;
            }

            this.newSearch = "";
            this.pop = false;

        })
        setTimeout(() => {
            this.dummy = false;
        }, 1000);

    }

    clearSearch() {
        this.newSearch = ''
    }
}
